<script>
import Parte1 from '/src/components/parte1.vue';
import Parte2 from '/src/components/parte2.vue';
import Parte3 from '/src/components/parte3.vue';
import Parte4 from '/src/components/parte4.vue';
import Parte5 from '/src/components/parte5.vue';
import Rodape from '/src/components/rodape.vue';
import Menu from '/src/components/header.vue';
import Carousel from '/src/components/carousel.vue';
import Video from '/src/components/video.vue';
import carimage1 from '@/components/carimage1.vue';
import carimage2 from '@/components/carimage2.vue';
import carimage3 from '@/components/carimage3.vue';
import image1 from '@/assets/imagens/imagemcarrossel1.png';
import image2 from '@/assets/imagens/imagemcarrossel2.png';
import image3 from '@/assets/imagens/imagemcarrossel3.png';

export default {
  name: 'Home',

  components: {
    Parte1,
    Parte2,
    Parte3,
    Parte4,
    Parte5,
    Rodape,
    Menu,
    Carousel,
    Video,
    carimage1,
    carimage2,
    carimage3
  },
  data() {
    return {
      images: [
        image1, image2, image3
      ],
      imagescarrossel: [carimage1, carimage2, carimage3]

    }
  }

}


</script>

<template>
  <div class="home">
    <div class="menu">

      <Menu />
    </div>
    <div class="">

      <Carousel :items="images">
        <template #default="{ item }">
          <div class="carousel">
            <img class="image_carousel" :src="item" alt="Carousel Image" />
          </div>
        </template>
      </Carousel> 


     <!-- <Carousel :items="imagescarrossel">
        <template #default="{item}" >
          <div class="carousel" >                                    
            <component :is="item"></component>   
          </div>
        </template>
      </Carousel> -->

    </div>
    <div class="fundo1">
      <Parte1 />
    </div>

    <div class="fundo2">
      <Parte2 />
    </div>
    <div class="fundo2">
      <Video></Video>
    </div>
    <div class="fundo3">
      <Parte3 />
    </div>
    <div class="fundo4">
      <Parte4 />
    </div>
    <div class="fundo5">
      <Parte5 />
    </div>
    <div class="rodape">
      <Rodape />
    </div>
  </div>
</template>

<style scoped>
.home {}

@media (max-width: 900px) {
  .menu {
    position: relative;
    width: 100%;
    z-index: 1;
  }

  .fundo1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .fundo2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    min-height: 100vh;
  }

  .fundo3 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    min-height: 90vh;
  }

  .fundo4 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .fundo5 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .rodape {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    max-width: 100%;
  }

  .fundo1::after {
    content: '';
    display: flex;
    align-items: center;
    background-image: linear-gradient(#ffffff, #ffffff);
    background-size: cover;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.9;
    /* ajuste a opacidade conforme necessário */
    z-index: -1;
    /* para colocar atrás do conteúdo */
  }

  .fundo2::after {
    content: '';
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 1;
    /* ajuste a opacidade conforme necessário */
    z-index: -1;
    /* para colocar atrás do conteúdo */
  }

  .fundo3::after {
    content: '';
    background-size: cover;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 1;
    /* ajuste a opacidade conforme necessário */
    z-index: -1;
    /* para colocar atrás do conteúdo */
  }

  .fundo4::after {
    content: '';
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 1;
    /* ajuste a opacidade conforme necessário */
    z-index: -1;
    /* para colocar atrás do conteúdo */
  }

  .fundo5::after {
    content: '';
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 1;
    /* ajuste a opacidade conforme necessário */
    z-index: -1;
    /* para colocar atrás do conteúdo */
  }

  .rodape::after {
    content: '';
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 1;
    /* ajuste a opacidade conforme necessário */
    z-index: -1;
    /* para colocar atrás do conteúdo */
  }


  .image_carousel {
    width: 100%;
    image-orientation: flip;
    object-fit: contain;
  }
}

@media (min-width: 901px) {
  .menu {
    position: relative;
    width: 100%;
    z-index: 1;
  }

  .fundo1 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 100vh;
  }

  .fundo2 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    min-height: 100vh;
  }

  .fundo3 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    min-height: 90vh;
  }

  .fundo4 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    min-height: 100vh;
  }

  .fundo5 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    min-height: 100vh;
  }

  .rodape {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    max-width: 100%;
  }

  .fundo1::after {
    content: '';
    display: flex;
    align-items: center;
    background-image: linear-gradient(#ffffff, #ffffff);
    background-size: cover;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0.9;
    /* ajuste a opacidade conforme necessário */
    z-index: -1;
    /* para colocar atrás do conteúdo */
  }

  .fundo2::after {
    content: '';
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 1;
    /* ajuste a opacidade conforme necessário */
    z-index: -1;
    /* para colocar atrás do conteúdo */
  }

  .fundo3::after {
    content: '';
    background-size: cover;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 1;
    /* ajuste a opacidade conforme necessário */
    z-index: -1;
    /* para colocar atrás do conteúdo */
  }

  .fundo4::after {
    content: '';
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 1;
    /* ajuste a opacidade conforme necessário */
    z-index: -1;
    /* para colocar atrás do conteúdo */
  }

  .fundo5::after {
    content: '';
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 1;
    /* ajuste a opacidade conforme necessário */
    z-index: -1;
    /* para colocar atrás do conteúdo */
  }

  .rodape::after {
    content: '';
    background-size: contain;
    background-repeat: no-repeat;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 1;
    /* ajuste a opacidade conforme necessário */
    z-index: -1;
    /* para colocar atrás do conteúdo */
  }


  .image_carousel {
    width: 100%;
    image-orientation: flip;
    object-fit: contain;
  }
}
</style>
